var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatAddColorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160903",
    "data-name": "Group 160903",
    transform: "translate(-212 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160881",
    "data-name": "Group 160881",
    transform: "translate(212 23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    fill: "none",
    stroke: "#818792",
    strokeWidth: 1,
    strokeDasharray: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    rx: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160883",
    "data-name": "Group 160883",
    transform: "translate(199 33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(26 11)",
    fill: "#818792",
    fontSize: 15,
    fontFamily: "Silka-Medium, Silka",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatAddColorIcon);
export default __webpack_public_path__ + "static/media/live-chat-add-color-icon.a61a5d6b7e1eb40443469b5ed52d557c.svg";
export { ForwardRef as ReactComponent };